export const LOGIN_PAGE_PATHNAME_REGEXP = /^\/login\/?$/;

export const CHOOSE_ORGANIZATION_PAGE_PATHNAME_REGEXP =
  /^\/login\/choose-organization\/?$/;

export const MINI_LK_PAGE_PATHNAME_REGEXP = /^\/login\/mini-lk\/?$/;

export const REQUIRED_SOFTWARE_PAGE_PATHNAME_REGEXP =
  /^\/login\/required-software\/?$/;

/**
 * INFO: Часть адреса, автоматически подставляемая НСПК (https://www.nspk.ru/) при редиректе в проект Свой Бизнес.
 * Для корректного перенаправления в целевой проект нам необходимо удалить её из адреса.
 */
export const NSPK_URL_SLUG = "/agreementToAgent";
